import { combineReducers } from '@reduxjs/toolkit'
import authSlice from './features/authSlice'
import applicationSlice from './features/applicationSlice'
const reducer = combineReducers({
     auth: authSlice,
    application: applicationSlice,
})

export default reducer
